// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AZPQ","colBig":"styles_colBig__368Fo","colSmall":"styles_colSmall__1AiQt","shopifyNameWrapper":"styles_shopifyNameWrapper__2pxfi"};